export default (etag) => {
   return etag.replaceAll('\\', '');
}